<button
  mat-stroked-button
  type="button"
  class="ai-settings-panel-trigger"
  [matMenuTriggerFor]="aiSettings"
>
  <mat-icon class="size-m">settings</mat-icon>
  {{ 'guidedCourseCreation.outline.aiSettings' | translate }}
</button>

<mat-menu
  #aiSettings="matMenu"
  xPosition="before"
  class="ai-settings-panel-menu"
>
  <div class="ai-settings-panel" (click)="$event.stopPropagation()">
    <h3 class="ai-settings-panel-title headline-tertiary">
      {{ 'guidedCourseCreation.outline.aiSettings' | translate }}
    </h3>

    <div class="ai-settings-panel-group">
      <mat-slide-toggle
        [checked]="contentGenerationEnabled()"
        (change)="contentGenerationEnabled.set($event.checked)"
      >
        {{ 'guidedCourseCreation.outline.generate.text' | translate }}
      </mat-slide-toggle>

      @if (showContentMode()) {
        <div
          class="ai-settings-panel-mode"
          animate.enter="expand-fade-enter"
          animate.leave="expand-fade-leave"
        >
          <app-segmented-toggle
            [options]="modeOptions"
            [value]="contentMode()"
            [ariaLabel]="'guidedCourseCreation.contentMode.label' | translate"
            (valueChange)="modeSelected.emit($event)"
          />
          @for (key of [modeDescriptionKey()]; track key) {
            <p
              class="ai-settings-panel-mode-description"
              animate.enter="fade-enter"
            >
              {{ key | translate }}
            </p>
          }
        </div>
      }
    </div>

    <mat-slide-toggle
      [checked]="contentGenerationEnabled() && imageGenerationEnabled()"
      [disabled]="!contentGenerationEnabled()"
      (change)="imageGenerationEnabled.set($event.checked)"
    >
      {{ 'guidedCourseCreation.outline.generate.images' | translate }}
    </mat-slide-toggle>
  </div>
</mat-menu>
